import PropTypes from 'prop-types';

import ExpandAnimation from 'Animation/ExpandAnimation';

import Alert from './Alert';

const AlertAnimated = ({ isShown, ...rest }) => {
  return (
    <ExpandAnimation className="overflow-hidden" isShown={isShown}>
      {<Alert {...rest} />}
    </ExpandAnimation>
  );
};

AlertAnimated.defaultProps = {
  isShown: false,
};

AlertAnimated.propTypes = {
  isShown: PropTypes.bool,
};

export default AlertAnimated;
